
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-03-24-remotion-part-3",
      function () {
        return require("private-next-pages/blogs/2024-03-24-remotion-part-3/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-03-24-remotion-part-3"])
      });
    }
  